
import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";
import Icon from "@/components/UI/Icon.vue";
import { iconNames } from "@/lib/icons/icons";
@Component({
  components: { Icon }
})
export default class ElementIcon extends Vue {
  @Prop()
  icon!: string;

  @Prop({ default: "14" })
  size!: string;

  get elementIcon() {
    return this.icon || "SquareIcon";
  }

  get elementIconIsLocal() {
    return iconNames.find(iconName => iconName === this.elementIcon);
  }
}
